import React from 'react'
import "./aboutcomp2.css"

const Aboutcomp2 = () => {
    return (
        <>
            <div className="about-2">
                <div className="about-content">
                        <h1> Hi.. My Name is <span> Muhammad Hammad Khan </span>  </h1>
                        <p>
                            I am a full-stack abd MERN-Stack web developer with a vast array of knowledge in many different front-end and back-end languages, responsive frameworks, databases, and best code practices.
                            I bring years of research and industry experience to the table and can understand requirements thoroughly, and build the software required by the client in a timely fashion.
                            I also work in blockchain and web3 space and am also proficient in solidity. I have deployed NFT (ERC721), staking, token, and DAFI based smart contracts.
                        </p>
                    <div className="per-info">
                        <div className="left-con">
                            <p>Birthday : 22/Nov/2000 </p>
                            <p>Degree:BSIT (Information Technology) </p>
                            <p>City:Hyderbabad </p>
                            <p>Country : Pakistan </p>
                        </div>
                        <div className="right-con">
                            <p>Age : 21 </p>
                            <p>Email : hk7356321@gmail.com </p>
                            <p>Phone : 0311-3318633 </p>
                            <p>Freelance: Available </p>
                        </div>
                    </div>
                    <div className="skills">
                        <div className="sec-1">
                            <p className='title'>HTML</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "90%" }}>
                                    <span className='tooltip'>90%</span>
                                </span>
                            </div>
                            <p className='title'>CSS</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "70%" }}>
                                    <span className='tooltip'>70%</span>
                                </span>
                            </div>
                            <p className='title'>JavaScript</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "70%" }}>
                                    <span className='tooltip'>70%</span>
                                </span>
                            </div>
                            <p className='title'>Bootstrap</p>
                            <div className="skill-bar margin">
                                <span className="skill-per" style={{ width: "60%" }}>
                                    <span className='tooltip'>60%</span>
                                </span>
                            </div>
                        </div>
                        <div className="sec-2">
                            <p className='title'>Node Js</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "65%" }}>
                                    <span className='tooltip'>65%</span>
                                </span>
                            </div>
                            <p className='title'>Express Js</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "75%" }}>
                                    <span className='tooltip'>75%</span>
                                </span>
                            </div>
                            <p className='title'>React Js</p>
                            <div className="skill-bar">
                                <span className="skill-per" style={{ width: "70%" }}>
                                    <span className='tooltip'>70%</span>
                                </span>
                            </div>
                            <p className='title'>Mongo DB</p>
                            <div className="skill-bar margin">
                                <span className="skill-per" style={{ width: "80%" }}>
                                    <span className='tooltip'>80%</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Aboutcomp2